var _path, _rect, _rect2, _rect3, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFillUpType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.875 22.8H20.125C20.9189 22.8 21.5625 22.2628 21.5625 21.6V2.4C21.5625 1.73726 20.9189 1.2 20.125 1.2H2.875C2.08109 1.2 1.4375 1.73726 1.4375 2.4V21.6C1.4375 22.2628 2.08109 22.8 2.875 22.8ZM20.125 24H2.875C1.28718 24 0 22.9255 0 21.6V2.4C0 1.07452 1.28718 0 2.875 0H20.125C21.7128 0 23 1.07452 23 2.4V21.6C23 22.9255 21.7128 24 20.125 24Z",
    fill: "#001B4A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 10,
    height: 1.3,
    rx: 0.554498,
    fill: "#001B4A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 10,
    height: 1.3,
    rx: 0.554498,
    fill: "#001B4A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 19,
    width: 10,
    height: 1.3,
    rx: 0.554498,
    fill: "#001B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.254 2.812V7H5.414V2.812H6.254Z",
    fill: "#001B4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.254 12.334H18.634V13H16.414V8.812H17.254V12.334Z",
    fill: "#001B4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.254 16.49V17.54H6.664V18.206H5.254V19.316H6.844V20H4.414V15.806H6.844V16.49H5.254Z",
    fill: "#001B4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillUpType);
export default __webpack_public_path__ + "static/media/fill-up-type.945d7a03324d4421e21a1a2b0152de37.svg";
export { ForwardRef as ReactComponent };